<template>
  <div class="flex flex-col">
    <div class="tabs flex flex-row tabs-bg font500">
      <div class="tab-head flex-1 flex flex-row-center flex-col-center" 
      :class="{'tab-acitve':current == index}" v-for="(item,index) in list" v-text="item.name" 
      :key="item.name" @click="handleClick(index)"></div>
    </div>
    <slot>
      <div class="flex-1 bg-common color-white padding-10 flex flex-col">
        <div class="flex flex-col" v-if="datas.length">
          <div class="goods-item" :class="{'m-t-10':index>0}" @click="goDetail(item.supportInfoId)" v-for="(item,index) in datas" :key="item.supportInfoId">
            <van-image :src="item.picUrl" fit="fill" width="100%" height="100%" lazy-load />
          </div>
        </div>
        <div class="flex flex-row-center flex-col-center top-139" v-if="false">
          <no-data show-type="help" imgHeight="109px" imgWidth="131px" :imgSize="131" desc="别看了什么活动都没有!">
            <div class="color-desc" slot="description" style="margin-top:-20px">
              别看了什么活动都没有！
            </div>
          </no-data>
        </div>
      </div>
    </slot>
  </div>
</template>
<script>
import noData from '@/components/noData.vue'
export default {
  components:{ noData },
  name:'help-item',
  data(){
    return {
      current:0
    }
  },
  props:{
    list:{
      type:Array,
      default:()=>[]
    },
    datas:{
      type:Array,
      default:()=>[]
    }
  },
  methods:{
    handleClick:function(current){
      console.log(this.current,current)
      if(this.current != current) this.$emit('change',current)
      this.current = current
    },
    goDetail:function(id){
      const param = {
        id:id
      }
      this.$navigateTo("help-detail",param)
    },
  }
}
</script>
<style lang="less" scoped>
/deep/ .tabs-bg{
  font-size: 16px;
  background: transparent;
  height: 44px;
  .tab-head{
    color: #FFFFFF;
    background: #FA6339;
    height: 100%;
    border-radius: 10px 10px 0 0;
    box-shadow:  0PX 3PX 6PX 0PX rgba(228, 59, 12, 0.74);
  }
  .tab-acitve{
    color: #E73F10;
    background: #FFE4A4;
    box-shadow: none;
  }
}
/deep/ .tabs-color{
  color: #E73F10;
}
/deep/ .goods-item{
  background: #F7AB25;
  height: 120px;
}
/deep/ .top-139{
  margin-top: 139px;
}
/deep/ .color-desc{
  color: #E38500;
  font-size: 12px;
}
</style>